import React, { useEffect, useState } from 'react'
import DashboardLayout, {DashboardPage} from '../layout'
import { useData } from '../../../data'
import { useRouter } from '../../../routes'
import { LeftOutlined } from '@ant-design/icons'
import  ToolForm  from './toolform'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import {Card, Form, notification} from 'antd'

/**
 * Tools Create page
 */

const NewToolPage = (props) => {
    const router = useRouter()
    const [form] = Form.useForm();
    const [cookieKeys, setNewCookieKeys] = useState([])
    const [error, setError] = useState(null)

    const data = useData()
    const tools = data.tools()

    const getcookieKeys = async () => {
        try {
            const allcookieKeys = await tools.getcookiekeys()
            setNewCookieKeys(allcookieKeys)
        } catch (error) {
            console.log(error.message)
        }

    }
     /**
     * Get data required 
     */
      useEffect(() => {
        getcookieKeys()
        // eslint-disable-next-line
    }, [])

    const { promiseInProgress } = usePromiseTracker()


    const createTool = details => {
        setError(null)
        const tools = data.tools()

        if (!promiseInProgress) {
            trackPromise(
                tools.createTool(details)
                    .then(data => {
                        console.log(data)
                        notification.success({
                            message: "Tool created successfully."
                        })
                        router.push(`/dashboard`)
                    })
                    .catch(err => {
                        console.log(err.message)
                        setError("An error occured")
                    })
            )
        }

    }

    const goBack = () => {
        router.push(`/dashboard`)
    }

    return (
        <DashboardLayout selected="new_tool" >
            <DashboardPage title="Create a new Tool" 
                ctaIcon={<LeftOutlined />}
                buttonText="Back"
                onCtaClick={() => goBack()}
            >

                <Card title="Tool information">

                    {/* Tool form */}
                    <ToolForm form={form} isEdit={false} onFinish={createTool}/>
                    
                </Card>
    
            </DashboardPage>
        </DashboardLayout>
    )
}

export default NewToolPage